import { message, Popover } from "antd";
import copy from "copy-to-clipboard";
import { ProverData } from "../AppList";
import styles from "./index.module.scss";
import { formatUnits } from "ethers";

import { useModalStore } from "@/store/modle";
import { useDataStore, WalletSource } from "@/store/dataStore";
import warning from "@/assets/images/warning.svg";
import closeRed from "@/assets/images/closeRed.svg";
import closeGray from "@/assets/images/closeGray.svg";
import WithdrawWaitingModal from "../modals/WithdrawWaitingModal";
import WithdrawSuccessModal from "../modals/WithdrawSuccessModal";
import { useEffect, useState } from "react";
import { useAccount, useChainId, useWriteContract } from "wagmi";
import {
  stakingAddress,
  targetChainId,
  tokenDecimals,
  tokenSymbol,
} from "../modals/StakeModal";
import { stakingABI } from "../modals/ABI";
import { JsonRpcProvider } from "ethers";
import { getChainInfoById } from "@/constants/const";
import { LoadingOutlined } from "@ant-design/icons";
import { formatDecimalWithSeparation } from "celer-web-utils/lib/format";
import { MoreDetailsContent } from ".";
import { useTransactionError } from "@/hooks/useTransactionError";

export enum WidthDrawStatus {
  stakeInit,
  staking,
  stakingSuccess,
}
let timer: any;
let timeouter: any;
export default function StakeCard({ stake }: { stake: ProverData }) {
  const { setShowStakeModal, setShowUnStakeModal } = useModalStore(
    (state) => state
  );
  const { setSelectedStake, walletSource, isMobile, tokenPrice } = useDataStore(
    (state) => state
  );
  const setShowWithdrawWaitingModal = useModalStore(
    (state) => state.setShowWithdrawWaitingModal
  );
  const showWithdrawWaitingModal = useModalStore(
    (state) => state.showWithdrawWaitingModal
  );
  const setShowWithdrawSuccessModal = useModalStore(
    (state) => state.setShowWithdrawSuccessModal
  );
  const showWithdrawSuccessModal = useModalStore(
    (state) => state.showWithdrawSuccessModal
  );
  const [txHash, setTxHash] = useState("");
  // const [proverTotalAmount, setProverTotalAmount] = useState("");
  const [stakeLoading, setStakeLoading] = useState(false);
  const [stakeError, setStakeError] = useState(false);

  const [shouldSwitchChain, setShouldSwitchChain] = useState(false);
  const [chainId, setChainId] = useState(1);
  const [stakeStatus, setStakeStatus] = useState<WidthDrawStatus>(
    WidthDrawStatus.staking
  );
  const { address, connector } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const id = useChainId();
  const setShowChainSwitchWarningModal = useModalStore(
    (state) => state.setShowChainSwitchWarningModal
  );

  useTransactionError(stakeError, isMobile);

  useEffect(() => {
    setShowChainSwitchWarningModal(false);
  }, []);

  useEffect(() => {
    if (stakeError) {
      setTimeout(() => {
        setStakeError(false);
      }, 30000);
    }
  }, [stakeError]);

  useEffect(() => {
    if (
      walletSource === WalletSource.FromWeb &&
      connector?.name !== "Coinbase Wallet"
    ) {
      if (chainId === targetChainId) {
        setShouldSwitchChain(false);
        setShowChainSwitchWarningModal(false);
      } else {
        setShouldSwitchChain(true);
      }
    } else {
      if (id === targetChainId) {
        setShouldSwitchChain(false);
        setShowChainSwitchWarningModal(false);
      } else {
        setShouldSwitchChain(true);
      }
    }
  }, [id, chainId, walletSource, targetChainId]);

  // const getProverInfo = async () => {
  //   const provider = new JsonRpcProvider(
  //     getChainInfoById(
  //       Number(process.env.REACT_APP_PUBLIC_CLAIM_CHAIN || 59144)
  //     ).rpcUrl
  //   );
  //   const staking_viewer_contract = new Contract(
  //     contract_address.staking_viewer || "",
  //     StakingViewer_Contract_ABI,
  //     provider
  //   );
  //   const res = await staking_viewer_contract.getProverInfo(
  //     stake.proverAddress
  //   );
  //   setProverTotalAmount(res.totalAssets);
  //   console.log("🚀 ~ getProverInfo ~ res:", res);
  // };

  // useEffect(() => {
  //   if (!stake) {
  //     return;
  //   }
  //   getProverInfo();
  // }, [stake]);
  useEffect(() => {
    if (!connector) {
      return;
    }
    if (
      connector?.name === "WalletConnect" ||
      connector?.name === "Coinbase Wallet"
    ) {
      setChainId(id);
    } else {
      if (typeof window.ethereum !== "undefined") {
        const fetchChainId = async () => {
          try {
            const targetChainId = await window.ethereum.request({
              method: "eth_chainId",
            });
            setChainId(parseInt(targetChainId));
            console.log("chainId22:", parseInt(targetChainId));
          } catch (error) {
            console.error("get chainId error:", error);
          }
        };
        fetchChainId();
        const handleChainChanged = (newChainId: any) => {
          setChainId(parseInt(newChainId));
        };
        window.ethereum.on("chainChanged", handleChainChanged);
        return () => {
          window.ethereum.removeListener("chainChanged", handleChainChanged);
        };
      } else {
        console.error("MetaMask error");
      }
    }
  }, [connector, id]);

  const copyText = (address: string) => {
    copy(address || "");
    message.success("copy success !");
  };
  const widthDraw = async (addr: string) => {
    if (shouldSwitchChain) {
      setShowChainSwitchWarningModal(true);
    }
    setStakeLoading(true);
    setStakeError(false);
    if (stakeLoading) {
      return;
    }
    if (!address) {
      setStakeLoading(false);
      return;
    }
    try {
      const res = await writeContractAsync({
        address: stakingAddress,
        abi: stakingABI,
        functionName: "completeUnstake",
        args: [addr],
      });
      getHash(res);
      setStakeStatus(WidthDrawStatus.staking);
      setShowWithdrawWaitingModal(true);
    } catch (error) {
      console.log("WidthDraw error", error);
      setStakeLoading(false);
      if (
        JSON.stringify(error?.toString()).indexOf("User denied transaction") ===
        -1
      ) {
        setStakeError(true);
        setStakeStatus(WidthDrawStatus.stakeInit);
        setShowWithdrawSuccessModal(false);
        setShowWithdrawWaitingModal(false);
      }
    }
  };

  const checkStatus = async (id: number, tx: string) => {
    const provider = new JsonRpcProvider(getChainInfoById(id).rpcUrl);
    const txReceipt = await provider.getTransactionReceipt(tx);
    if (txReceipt && txReceipt.status === 1) {
      clearTimeout(timeouter);
      clearInterval(timer);
      setStakeStatus(WidthDrawStatus.stakingSuccess);
      setShowWithdrawWaitingModal(false);
      setShowWithdrawSuccessModal(true);
      setStakeLoading(false);
    }
  };

  const getTransactionStatus = async (safeTxHash: string) => {
    const response = await fetch(
      `https://safe-client.safe.global/v1/chains/${targetChainId}/multisig-transactions/${safeTxHash}/raw`
    );
    const data = await response.json();

    if (data.transactionHash) {
      //data.confirmations?.length === data.confirmationsRequired
      setTxHash(data.transactionHash);
      setStakeStatus(WidthDrawStatus.staking);
      setShowWithdrawWaitingModal(true);
      if (data.isExecuted) {
        clearTimeout(timeouter);
        clearInterval(timer);
        setStakeStatus(WidthDrawStatus.stakingSuccess);
        setShowWithdrawWaitingModal(false);
        setShowWithdrawSuccessModal(true);
        setStakeLoading(false);
      }
    }
    return data.txStatus;
  };

  const getHash = async (txhash: string) => {
    if (!address || !connector) {
      return;
    }
    if (connector.name === "WalletConnect") {
      const res = await connector?.getProvider();
      const connectorInfo = res as any;

      const isSafe =
        connectorInfo?.session?.peer?.metadata?.name.indexOf("Safe") > -1;
      if (isSafe) {
        clearInterval(timer);
        timer = setInterval(() => {
          getTransactionStatus(txhash);
        }, 2000);
        clearTimeout(timeouter);
        timeouter = setTimeout(() => {
          clearInterval(timer);
          setStakeError(true);
          setStakeStatus(WidthDrawStatus.stakeInit);
          setShowWithdrawSuccessModal(false);
          setShowWithdrawWaitingModal(false);
          setStakeLoading(false);
        }, 5 * 60 * 1000);
        return;
      }
    }
    setTxHash(txhash);
    setStakeStatus(WidthDrawStatus.staking);
    setShowWithdrawWaitingModal(true);
    clearInterval(timer);
    timer = setInterval(() => {
      checkStatus(targetChainId || 1, txhash);
    }, 2000);
    clearTimeout(timeouter);
    timeouter = setTimeout(() => {
      clearInterval(timer);
      setStakeError(true);
      setStakeStatus(WidthDrawStatus.stakeInit);
      setShowWithdrawSuccessModal(false);
      setShowWithdrawWaitingModal(false);
      setStakeLoading(false);
    }, 1 * 60 * 1000);
  };

  return (
    <div className={styles.stakingCard}>
      <div className={styles.stakingCardHead}>
        <div className={styles.stakingCardHeadLeft}>
          <img
            src={stake.proverIcon || "/prover.png"}
            alt=""
            style={{
              width: isMobile ? "40px" : "44px",
              height: isMobile ? "40px" : "44px",
              marginRight: 6,
              borderRadius: "100%",
            }}
          />
          <div className={styles.stakingCardHeadText}>
            <div className={styles.stakingName}>{stake.proverName}</div>{" "}
            <div className={styles.stakingAddr}>
              {stake.proverAddress?.slice(0, 6) +
                "..." +
                stake.proverAddress?.slice(
                  stake.proverAddress.length - 4,
                  stake.proverAddress.length
                )}
              {/* 0x002C...de43 */}
              <img
                src={"/copy.svg"}
                alt="copy"
                onClick={() => copyText(stake.proverAddress || "")}
                style={{ marginLeft: 4, cursor: "pointer" }}
              />
            </div>
          </div>
        </div>
        <Popover
          placement="bottomRight"
          content={<MoreDetailsContent data={stake} tokenPrice={tokenPrice} />}
          rootClassName={styles.detailsPopover}
          trigger="hover"
        >
          <div
            className={styles.stakingDetailsBtn}
            // onClick={() => setActive(!active)}
            // className={`${styles.stakingDetailsBtn} ${
            //   active ? styles.active : ""
            // }`}
          >
            More Details
          </div>
        </Popover>
      </div>
      <div className={styles.stakingLine} />
      <div className={styles.stakingAmount}>
        <div className={styles.stakingAmountDes}>
          Staked Amount{" "}
          <Popover
            placement="top"
            content={`This is the total amount of ${localStorage.getItem(
              "symbol"
            )} you currently stake with this prover.`}
            rootClassName={styles.stakingPopover}
          >
            <img src="/info.svg" alt="Brevis" width="16px" />
          </Popover>
        </div>
        <div className={styles.stakingAmountNum}>
          {stake.proverStaked === 0n ? (
            <span style={{ color: "rgba(43, 48, 59, 0.6)" }}>
              {stake.proverStakedFormatted} {tokenSymbol}
            </span>
          ) : (
            <Popover
              placement="top"
              content={`${stake?.proverStakedDecimal} ${tokenSymbol}`}
              rootClassName={`${styles.stakingPopover} ${styles.feePopover}`}
              getPopupContainer={(triggerNode) =>
                triggerNode.parentElement || document.body
              }
            >
              {stake.proverStakedFormatted} {tokenSymbol}
            </Popover>
          )}
        </div>
      </div>
      <div className={styles.stakingAmount}>
        <div className={styles.stakingAmountDes}>
          Pending Unstake Amount
          <Popover
            placement="top"
            content="Unstaking takes 7 days to process. This is your unstaked amount that is still pending in the process with this prover."
            rootClassName={styles.stakingPopover}
          >
            <img src="/info.svg" alt="Brevis" width="16px" />
          </Popover>
        </div>
        <div className={styles.stakingAmountNum}>
          {stake.pendingUnstake === 0n ? (
            <span style={{ color: "rgba(43, 48, 59, 0.6)" }}>
              {stake.pendingUnstakeFormatted} {tokenSymbol}
            </span>
          ) : (
            <Popover
              placement="top"
              content={`${stake?.pendingUnstakeDecimal} ${tokenSymbol}`}
              rootClassName={`${styles.stakingPopover} ${styles.feePopover}`}
              getPopupContainer={(triggerNode) =>
                triggerNode.parentElement || document.body
              }
            >
              {stake.pendingUnstakeFormatted} {tokenSymbol}
            </Popover>
          )}
        </div>
      </div>
      <div className={styles.stakingAmount}>
        <div className={styles.stakingAmountDes}>
          Withdrawable Amount
          <Popover
            placement="top"
            content="This is your unstaked amount with this prover that has passed the 7-day process window and can be withdrawn immediately."
            rootClassName={styles.stakingPopover}
          >
            <img src="/info.svg" alt="Brevis" width="16px" />
          </Popover>
        </div>
        <div className={styles.stakingAmountNum}>
          {stake.withdrawable === 0n ? (
            <span style={{ color: "rgba(43, 48, 59, 0.6)" }}>
              {stake.withdrawableFormatted} {tokenSymbol}
            </span>
          ) : (
            <Popover
              placement="top"
              content={`${stake?.withdrawableDecimal} ${tokenSymbol}`}
              rootClassName={`${styles.stakingPopover} ${styles.feePopover}`}
              getPopupContainer={(triggerNode) =>
                triggerNode.parentElement || document.body
              }
            >
              {stake.withdrawableFormatted} {tokenSymbol}
            </Popover>
          )}
        </div>
      </div>

      <div className={styles.stakingCardBtn}>
        <div
          style={{
            cursor:
              stakeLoading ||
              Number(
                formatDecimalWithSeparation(
                  stake.withdrawable?.toString() || "0",
                  2,
                  tokenDecimals,
                  "floor",
                  "",
                  true
                ) || 0
              ) < 0.01
                ? "not-allowed"
                : "pointer",
            borderColor: stakeLoading
              ? " rgba(43, 48, 59, 0.3)"
              : "  rgba(43, 48, 59, 1)",
            color: stakeLoading
              ? " rgba(43, 48, 59, 0.3)"
              : "  rgba(43, 48, 59, 1)",
          }}
          className={
            Number(
              formatDecimalWithSeparation(
                stake.withdrawable?.toString() || "0",
                2,
                tokenDecimals,
                "floor",
                "",
                true
              ) || 0
            ) < 0.01
              ? styles.stakingDetailsBtnSpDisable
              : styles.stakingDetailsBtnSp
          }
          onClick={() => {
            if (
              Number(
                formatDecimalWithSeparation(
                  stake.withdrawable?.toString() || "0",
                  2,
                  tokenDecimals,
                  "floor",
                  "",
                  true
                ) || 0
              ) < 0.01
            ) {
              return;
            }
            widthDraw(stake.proverAddress || "");
          }}
        >
          <div style={{ position: "relative" }}>
            Withdraw
            {stakeLoading && (
              <LoadingOutlined
                style={{
                  fontSize: 22,
                  position: "absolute",
                  top: 0,
                  right: 25,
                  color: "rgba(43, 48, 59, 0.7)",
                }}
              />
            )}
          </div>
        </div>
        <div
          style={{ minWidth: isMobile ? 119 : 152 }}
          className={
            Number(
              formatDecimalWithSeparation(
                stake.proverStaked || "0",
                2,
                tokenDecimals,
                "floor",
                "",
                true
              ) || 0
            ) < 0.01
              ? styles.stakingDetailsBtnSpDisable
              : styles.stakingDetailsBtnSp
          }
          onClick={() => {
            if (
              Number(
                formatDecimalWithSeparation(
                  stake.proverStaked?.toString() || "0",
                  2,
                  tokenDecimals,
                  "floor",
                  "",
                  true
                ) || 0
              ) < 0.01
            ) {
              return;
            }
            setSelectedStake(stake);
            setShowUnStakeModal(true);
          }}
        >
          Request Unstake
        </div>
        {!stake.isActive ? (
          <Popover
            placement="bottom"
            content={
              "This prover is currently inactive and staking is not available."
            }
            rootClassName="na_popover"
            getPopupContainer={(triggerNode) =>
              triggerNode.parentElement || document.body
            }
          >
            <div
              style={{ minWidth: isMobile ? 89 : 115 }}
              className={`${styles.stakingDetailsBtnSpDisable} ${styles.stakingDetailsDarkBtn}`}
            >
              Stake More
            </div>
          </Popover>
        ) : (
          <div
            style={{ minWidth: isMobile ? 89 : 115 }}
            className={`${styles.stakingDetailsBtnSp} ${styles.stakingDetailsDarkBtn}`}
            onClick={() => {
              setSelectedStake(stake);
              setShowStakeModal(true);
            }}
          >
            Stake More
          </div>
        )}
      </div>
      <div className={styles.stakingWarn}>
        <img src={warning} alt="warn" style={{ marginRight: 6 }} />
        Unstaking takes ~7 days to process.
      </div>
      {stakeStatus === WidthDrawStatus.staking
        ? showWithdrawWaitingModal && <WithdrawWaitingModal txHash={txHash} />
        : showWithdrawSuccessModal && <WithdrawSuccessModal txHash={txHash} />}
      {stakeError && !isMobile && (
        <div className={styles.errorTips}>
          <img src={closeRed} alt="" width={32} />
          Transaction failed. Please try again.
          <img
            src={closeGray}
            alt=""
            width={24}
            className={styles.closeBtn}
            onClick={() => {
              setStakeError(false);
            }}
          />
        </div>
      )}
    </div>
  );
}
